<template>
	<v-dialog v-model="dialog" persistent scrollable max-width="600px" hide-overlay>
		<template v-slot:activator="{ on }">
			<v-btn color="secondary" class="text-lowercase mr-4" dark small v-on="on">{{'add spot' | localize}}</v-btn>
		</template>
		<v-card v-if="isLoaded">
			<v-card-title class="subtitle-1 pt-6">
				{{'New spot parameters' | localize}}
			</v-card-title>
			<v-divider></v-divider>
			<v-card-text class="black--text">
				<v-container grid-list-md>
					<v-form v-model="valid" ref="form" validation>
						<v-row>
							<v-col cols="12" md="6" sm="6">
								<v-select dense return-object 
									v-model="trademark" 
									:items="teamTrademarks"
									item-text="name" 
									item-value="id" 
									color="secondary" 
									item-color="secondary"
									:label="'Trademark' | localize" 
									@change="onceMore()" 
									:rules="[rules.required]">
								</v-select>
							</v-col>
							<v-col cols="12" sm="6" md="6">
								<v-select dense color="secondary" 
									:label="'Objective' | localize" 
									v-model="objective"
									:items="objectives"
									:item-text="`text_${locale.split('-')[0]}`"
									item-value="value"
									item-color="secondary" 
									:rules="[rules.required]"
									@change="onceMore()">
								</v-select>
							</v-col>
							<v-col cols="12" sm="6" md="3">
								<v-text-field dense color="primary" 
									:label="'Quality' | localize" 
									v-model.number="quality"
									name="quality" type="text" 
									:hint="'its expected number between 1 and 5' | localize" 
									persistent-hint
									:rules="[rules.required, rules.number, rules.max]" @change="onceMore()">
								</v-text-field>
							</v-col>
							<v-col cols="12" sm="6" md="4">
								<v-text-field dense color="primary" 
									:label="'Spots budget' | localize" 
									v-model.number="budget"
									name="budget" type="text" prefix="$" 
									:hint="'its expected number' | localize" 
									persistent-hint
									:rules="[rules.required, rules.number]" @change="onceMore()">
								</v-text-field>
							</v-col>
							<v-col cols="12" sm="6" md="5">
								<v-text-field dense color="secondary" 
									:label="'Spot name' | localize" 
									v-model="name" 
									type="text"
									readonly>
								</v-text-field>
							</v-col>

							<v-col cols="12" sm="12" md="12">
								<v-select dense multiple color="secondary" 
									:label="'Channels' | localize" 
									v-model="channels"
									:items="all_channels"
									:item-text="`text_${locale.split('-')[0]}`"
									item-value="value"
									item-color="secondary" 
									:rules="[rules.required]"
									@change="onceMore()" 
									@input="checkChannel($event)">
								</v-select>
							</v-col>
							<v-col cols="12" sm="12" md="12">
								<v-select dense 
									return-object
									color="secondary" 
									:label="'Commercial story' | localize"
									v-model="commercial_story" 
									:items="commercial_stories" 
									item-text="text"
									item-color="secondary" 
									:rules="[rules.required]" 
									@change="onceMore()">
									<!-- Полный текст при наведении на элемент списка -->
									<template v-slot:item="{ item }">
										<v-tooltip top color="primary">
											<template v-slot:activator="{ on, attrs }">
												<v-list-item-content v-bind="attrs" v-on="on">
													<v-list-item-title>
														{{ truncateText(item.text, 82) }}
													</v-list-item-title>
												</v-list-item-content>
											</template>
											<div class="text-center width_250">
												{{ item.text }}
											</div>
										</v-tooltip>
									</template>
								</v-select>
							</v-col>
						</v-row>
						<v-row v-if="IsTargeted">	
							<v-col cols="12" class="secondary--text">{{'Targeting parameters are available if at least one targeted channel is chosen' | localize}}</v-col>
							<hr />
							<v-col cols="12" sm="4" md="3">
								<v-text-field dense color="secondary" 
									:label="'Min age' | localize" 
									v-model.number="age_min" type="text"
									:hint="'its expected number' | localize" 
									persistent-hint
									:rules="[rules.required, rules.number]" @change="onceMore()">
								</v-text-field>
							</v-col>
							<v-col cols="12" sm="4" md="3">
								<v-text-field dense color="secondary" 
									:label="'Max age' | localize" 
									v-model.number="age_max" type="text"
									:hint="'its expected number' | localize" 
									persistent-hint
									:rules="[rules.required, rules.number]" @change="onceMore($event)">
								</v-text-field>
							</v-col>
							
							<v-col cols="12" sm="6" md="4">
								<v-select dense color="secondary" 
									:label="'Dominant gender' | localize"
									v-model="gender" 
									:items="DOMINANT_GENDER"
									:item-text="`text_${locale.split('-')[0]}`"
									item-value="value"
									item-color="secondary" 
									:rules="[rules.required]" @change="onceMore()">
								</v-select>
							</v-col>
							<v-col cols="12" sm="6" md="4">
								<v-select dense color="secondary" 
									:label="'Income range' | localize"
									v-model="income" 
									:items="INCOME_RANGE"
									:item-text="`text_${locale.split('-')[0]}`"
									item-value="value"
									item-color="secondary" :rules="[rules.required]" @change="onceMore()">
								</v-select>
							</v-col>
							<v-col cols="12" sm="6" md="4">
								<v-select dense color="secondary" 
									:label="'Education' | localize"
									v-model="education" 
									:items="EDUCATION"
									:item-text="`text_${locale.split('-')[0]}`"
									item-value="value"
									item-color="secondary" :rules="[rules.required]" @change="onceMore()">
								</v-select>
							</v-col>
							<v-col cols="12" sm="6" md="4">
								<v-select dense color="secondary" 
									:label="'Civil status' | localize"
									v-model="status" 
									:items="CIVIL_STATUS"
									:item-text="`text_${locale.split('-')[0]}`"
									item-value="value"
									item-color="secondary" :rules="[rules.required]" @change="onceMore()">
								</v-select>
							</v-col>
							<v-col cols="12" sm="6" md="4">
								<v-select dense color="secondary" 
									:label="'Workplace' | localize"
									v-model="workplace" 
									:items="WORKPLACE"
									:item-text="`text_${locale.split('-')[0]}`"
									item-value="value"
									item-color="secondary" :rules="[rules.required]" @change="onceMore()">
								</v-select>
							</v-col>
							<v-col cols="12" sm="6" md="4">
								<v-select dense color="secondary" 
									:label="'Lifestyle' | localize"
									v-model="lifestyle" 
									:items="LIFESTYLE"
									:item-text="`text_${locale.split('-')[0]}`"
									item-value="value" 
									item-color="secondary" :rules="[rules.required]" @change="onceMore()">
								</v-select>
							</v-col>
						</v-row>
					</v-form>
				</v-container>
				<div ref="bottomMarker"></div>
				<v-row v-if="error" class="text-center error--text">{{'Error' | localize }} => {{ error }}</v-row>
				<v-row class="text-start text-pre-wrap mx-2">{{ message }}</v-row>
			</v-card-text>
			<v-divider></v-divider>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn color="secondary" text class="text-capitalize" :disabled="!valid || Boolean(error)"
					@click="calculating">
					{{'Calculate' | localize}}
				</v-btn>

				<v-btn color="secondary" text class="text-capitalize" :disabled="!calculate || Boolean(error)"
					@click="addSpot">
					{{'Save' | localize}}
				</v-btn>

				<v-btn color="secondary" text class="text-capitalize" @click="closeDialog">
					{{'Close' | localize}}
				</v-btn>

			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import localizeFilter from '../../../filters/localize.filter.js';
import { CheckBudget, SpotCoverageCost, SpotInvestments } from '../../../functions/promotion.js'
export default {
	name: 'AddTeamSpot',
	data() {
		return {
			dialog: false,
			valid: false,
			isLoaded: false,
			error: '',
			message: '',
			calculate: false,
			rules: {
				required: v => !!v || localizeFilter('required field'),
				number: v => /^[+]?[0-9]/.test(v) || localizeFilter('its expected number'),
				max: v => v <= 5 || localizeFilter('max 5 expected'),
			},
			//props
			trademark: null,
			channels: [],
			commercial_story: {},
			objective: '',
			quality: 1,
			investments: 0,
			budget: 0,
			coverage_general: 0,
			coverage_targeted: 0,
			age_min: 0,
			age_max: 0,
			gender: 'any',
			income: 'any',
			education: 'any',
			status: 'any',
			workplace: 'any',
			lifestyle: 'any',
			IsTargeted: false,
		}
	},
	computed: {
		locale() {
			return this.$store.getters.locale;
		},
		game() {
			return this.$store.getters.game;
		},
		team() {
			return this.$store.getters.team;
		},
		spots() {
			return this.$store.getters.spots;
		},
		trademarks() {
			return this.$store.getters.trademarks;
		},
		segments() {
			return this.$store.getters.market_segments;
		},
		media() {
			return this.$store.getters.media;
		},
		commercial_stories() {
			return this.$store.getters.commercial_stories;
		},
		/*constants*/
		all_channels() {
			return this.$store.getters.CHANNELS;
		},
		objectives() {
			return this.$store.getters.OBJECTIVES;
		},
		DOMINANT_GENDER () {
			return this.$store.getters.DOMINANT_GENDER;
		},
		INCOME_RANGE() {
            return this.$store.getters.INCOME_RANGE;
        },
        EDUCATION() {
            return this.$store.getters.EDUCATION;
        },
        CIVIL_STATUS() {
            return this.$store.getters.CIVIL_STATUS;
        },
        WORKPLACE() {
            return this.$store.getters.WORKPLACE;
        },
        LIFESTYLE() {
            return this.$store.getters.LIFESTYLE;
        },
		teamTrademarks() {
			let res = [];
			if (this.team) {
				const arr = [];
				this.team?.products.map(prod => {
					const inArr = arr.find(it => it === prod.trademarkId)
					if (!inArr) {
						arr.push(prod.trademarkId)
					}
				})
				res = this.trademarks.filter(it => arr.indexOf(it.id) !== -1)
			}
			return res
		},
		marketSize() {
			let res = 0;
			if (this.segments.length > 0) {
				res = this.segments.reduce((sum, item) => {
					return sum += item.segment.peak_size;
				}, 0)
			}
			return res;
		},
		name: {
			get() {
				if (this.trademark) {
					return `${this.trademark.name} Ad`
				}
				return ''
			},
			set(val) {
				return val;
			}
		},
	},
	methods: {
		localeNumber(num) {
			if (this.locale == 'ro-RO') {
				return num.toLocaleString('en-US')
			}
			return num.toLocaleString(this.locale)
		},
		onceMore() {
			this.error = ''
			this.calculate = false;
			this.message = '';
		},
		truncateText(text, maxLength) {
			if (!text) return '';
			return text.length > maxLength ? text.slice(0, maxLength) + '...' : text;
		},
		checkChannel(event) {
			const arr = ['SMM', 'content ads', 'bloggers & influencers', 'banner ads'];
			for (let i=0; i < event.length; i++) {
				if (arr.includes(event[i])) {
					this.IsTargeted = true;
					return;
				}
			}
			this.IsTargeted = false;
		},
		calculating() {
			if (this.$refs.form.validate()) {
				const exist = this.spots?.find(spot => spot.name == this.name)
				if (exist) {
					return this.error = localizeFilter(`The promotional spot for this trademark already exists`)
				}

				//check budget
				const check_budget = CheckBudget(this.channels, this.media, this.budget);
				//console.log(check_budget);
				if (!check_budget) {
					return this.error = localizeFilter(`Insufficient budget`) + `: ${this.budget}`;
				}

				this.investments = SpotInvestments(this.quality, this.channels);
				/* chennels coverage */
				[this.coverage_general, this.coverage_targeted] = SpotCoverageCost(this.channels, this.marketSize, this.media, check_budget);

				/* console.log(this.locale);*/
				if (this.locale == 'ro-RO') {
					this.message = `Vă rugăm să luați notă:

					Investiții de spot = $${this.localeNumber(this.investments)}
					Acoperirea pieței prin publicitate generală = ${this.localeNumber(this.coverage_general)}
					Acoperirea pieței prin publicitate targetată = ${this.localeNumber(this.coverage_targeted)} 
					--------------------------------------------------------------
					Dacă sunteți de acord, apăsați butonul "Salvare", altfel - apăsați "Închide"`
				} 
				else if (this.locale == 'ru-RU') {
					this.message = `Пожалуйста, обратите внимание:

					Инвестиции в ролик = $${this.localeNumber(this.investments)}
					Охват рынка за счёт общей рекламы = ${this.localeNumber(this.coverage_general)}
					Охват рынка за счёт таргетированной рекламы = ${this.localeNumber(this.coverage_targeted)} 
					-------------------------------------------------------
				Согласны? Нажмите кнопку "Сохранить", иначе — кнопку "Закрыть"`
				}
				else {
					this.message = `Please take note:

					Spot investment = $${this.localeNumber(this.investments)}
					Market coverage by general advertising = ${this.localeNumber(this.coverage_general)}
					Market coverage by targeted advertising = ${this.localeNumber(this.coverage_targeted)} 
					---------------------------------------------------------
					If you agree, press the button "Save", else - press "Close"`
				}
				//goto ref = bottomMarker
				this.$nextTick(() => {
					const el = this.$refs.bottomMarker;
					if (el) {
						el.scrollIntoView({ behavior: 'smooth' });
					}
				});
				this.calculate = true;
			}

		},
		async addSpot() {

			if (this.$refs.form.validate()) {
				
				const typical_age = [];
				
				if (this.age_min || this.age_max) {
					typical_age[0] = this.age_min;
					typical_age[1] = this.age_max;
				}
				
				const spot = {
					gameId: Number(this.game.id),
					round: Number(this.game.round),
					register_round: Number(this.game.round),
					team: this.team,
					name: this.name,
					objective: this.objective,
					quality: this.quality,
					trademark: this.trademark,
					commercial_story: this.commercial_story,
					channels: this.channels,
					investments: this.investments,
					budget: this.budget,
					coverage_general: this.coverage_general,
					coverage_targeted: this.coverage_targeted,
					typical_age: typical_age,
					gender: this.gender,
					income: this.income,
					education: this.education,
					civil_status: this.status,
					job: this.workplace,
					lifestyle: this.lifestyle,
				}
				/*console.log(spot);*/ 
				try {
					//add spot 
					await this.$store.dispatch('addTeamSpot', spot)
					this.closeDialog()
				}
				catch (error) {
					this.error = `Error: ${error.message}`;
					this.message = '';
					this.$store.dispatch('setError', error.message)//throw error
				}
			}
		},
		closeDialog() {
			//reset
			this.dialog = false;
			this.error = '';
			this.message = '';
			this.calculate = false;

			this.name = '';
			this.$refs.form.reset();
			this.trademark = [];
			this.channels = [];
			this.objective = ''
			this.quality = 1
		}
	},
	async created() {
	
		if (this.game) {

			if (!this.commercial_stories) {
				try {
					await this.$store.dispatch('fetchCommercialStories', this.game.category);
				}
				catch (error) {
					await this.$store.dispatch('setError', error.message)
				}
			}

			/* force loading market-segments this year */	
			try {
				await this.$store.dispatch('fetchMarketSegments', { gameId: this.game.id, round: this.game.round });
			}
			catch (error) {
				await this.$store.dispatch('setError', error.message)
			}

			/* force loading media this year */	
			try {
				await this.$store.dispatch('fetchMedia', {
					gameId: this.game.id, round: this.game.round
				});
			}
			catch (error) {
				await this.$store.dispatch('setError', error.message)
			}
		}

		if (this.trademarks?.length < 1) {
			try {
				await this.$store.dispatch('fetchTrademarks');
			}
			catch (error) {
				await this.$store.dispatch('setError', error.message)
			}
		}
		
		this.isLoaded = true;
	},
}
</script>
